import React from 'react';
import './Mixedbucktable.css';



const Mixedbucktable = () => {
    return (
        <div className="mold-container">
            <h2 className="heading">Do you want to know how mixed-color plastic buckets are made?</h2>
            
            <div className="details-grid">
                <div className="left-column">
                    <p><strong>Machine Model</strong> </p>
                    <p><strong>Product</strong> </p>
                    <p><strong>Weight</strong></p>
                    <p><strong>Diameter	</strong></p>
                    <p><strong>Material</strong></p>
                </div>
                <div className="right-column">
                    <p>CM560-S6</p>
                    <p>20L Plastic Buckets</p>
                    <p>540G</p>
                    <p>	390*312mm</p>
                    <p>PP</p>
                </div>
            </div>
        </div>
    );
};

export default Mixedbucktable;
